import classNames from "classnames/bind";
import Icon from "../../../../Foundation/Icons";
import { IconColours } from "../../../../Foundation/Icons/interface";
import { LabelledIconButtonProps } from "../../interface";
import classes from "./labelledIconButton.module.scss";

const LabelledIconButton = ({
    size = "16",
    label,
    name,
    onClick,
    orientation = "",
    theme = "",
    iconColour = IconColours.white,
    disabled = false,
}: LabelledIconButtonProps) => {
    const cx = classNames.bind(classes);
    const labelledIconButtonClasses = cx({
        labelledIconButton: true,
        [orientation]: !!orientation,
        [theme]: !!theme,
    });

    return (
        <button
            type="button"
            className={labelledIconButtonClasses}
            onClick={onClick}
            disabled={disabled}
            data-testid="labelled-icon-button"
        >
            <Icon
                name={name}
                colour={iconColour}
                size={size}
                ariaHidden={true}
            ></Icon>
            <span>{label}</span>
        </button>
    );
};

export default LabelledIconButton;
